import { render, staticRenderFns } from "./modal1.vue?vue&type=template&id=00f13bfe&scoped=true"
import script from "./modal1.vue?vue&type=script&lang=js"
export * from "./modal1.vue?vue&type=script&lang=js"
import style0 from "./modal1.vue?vue&type=style&index=0&id=00f13bfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f13bfe",
  null
  
)

export default component.exports